import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { GrainOverlay } from "@/components/effects/GrainOverlay";
import { PremiumCursor } from "@/components/effects/PremiumCursor";
import { SpotlightController } from "@/components/effects/SpotlightController";
import Index from "./pages/Index.tsx";
import State from "./pages/State.tsx";
import Glp1Calculator from "./pages/Glp1Calculator.tsx";
import BlogGlp1DosingSchedules from "./pages/BlogGlp1DosingSchedules.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <GrainOverlay />
      <SpotlightController />
      <PremiumCursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/states/:state" element={<State />} />
          <Route path="/tools/glp-1-calculator" element={<Glp1Calculator />} />
          <Route path="/blog/glp-1-dosing-schedules" element={<BlogGlp1DosingSchedules />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
